import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

const DropdownMenuItemCustom = ({
  children,
  className = "",
  selected,
  ...rest
}: {
  children: React.ReactNode;
  className?: string;
  selected?: boolean;
} & React.ComponentProps<typeof DropdownMenuPrimitive.Item>) => (
  <DropdownMenuPrimitive.Item
    className={`dropdown-menu-item-base dropdown-menu-item-custom ${className} ${selected ? "dropdown-menu-item--selected" : ""}`.trim()}
    {...rest}
  >
    {children}
  </DropdownMenuPrimitive.Item>
);

export default DropdownMenuItemCustom;
DropdownMenuItemCustom.displayName = "DropdownMenuItemCustom";
